export default __webpack_public_path__ + "static/media/area-chart.6349761d.png";